import { notification, Modal } from 'ant-design-vue'
import _ from 'lodash'
import { defineComponent } from 'vue'

export default defineComponent({
  methods: {
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmNotificationSuccessMessage
    lmToastSuccessMessage (toastMessage, toastTitle, autoHideDelay = 4.5, props = {}) {
      const {
        notificationTitle = this.$t('good_title'),
        notificationPlacement = 'bottomLeft'
      } = props

      // https://app.clickup.com/t/383x729
      notification.success({
        message: notificationTitle,
        placement: notificationPlacement,
        description: toastMessage,
        duration: autoHideDelay })
    },
    lmNotificationSuccessMessage (props = {}) {
      props = _.defaultsDeep(props, {
        message: this.$t('good_title'),
        description: '',
        placement: 'bottomLeft',
        duration: 2.5,
        context: {}
      })

      // https://app.clickup.com/t/383x729
      notification.success({
        message: props.message,
        placement: props.placement,
        description: props.description,
        duration: props.duration,
        onClick: () => {
          // Download Click
          if (props.context?.type === 'download') {
            const a = document.createElement('a')
            a.download = ''
            a.href = props.context.link
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()
          }
        }
      })
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalWarningMessage
    lmToastWarningMessage (toastMessage, toastTitle, autoHideDelay = 2, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'warning',
        resultTitle: this.$t('something_went_wrong'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalWarningMessage (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'warning',
        resultTitle: this.$t('something_went_wrong'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalDangerMessage
    lmToastDangerMessage (toastMessage, toastTitle, autoHideDelay = 2, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'error',
        resultTitle: this.$t('error_found'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalDangerMessage (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'error',
        resultTitle: this.$t('error_found'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalSuccessWithButtons
    lmToastSuccessInternalLink (routerLinkToProperty, toastMessage, toastTitle, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('view'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: routerLinkToProperty,
        modalWidth: 600,
        resultStatus: 'success',
        resultTitle: this.$t('good_title'),
        resultSubtitle: '',
        extraMessageColor: 'green',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalSuccessWithButtons (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('view'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: props.btnLink,
        modalWidth: 600,
        resultStatus: 'success',
        resultTitle: this.$t('good_title'),
        resultSubtitle: '',
        extraMessageColor: 'green',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    lmModalInformationMessage (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'information',
        resultTitle: this.$t('attention'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'black',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    /**
     * Asociado a las mejoras en mensajes de error y exito:
     * https://app.clickup.com/t/383x729
     * Se crea este metodo y se refactorean los toasts y mensajes
     * Los mensajes de error y warning se asumen a partir de ahora que se
     * deben mostrar en un modal, para requerir atencion del usuario.
     *
     * Los mensajes de success por defecto se van a mostrar como notifications
     * de antd https://app.clickup.com/t/383x729.
     *
     * En caso que un mensaje de success sea importante en el producto se va a
     * mostrar como un modal.
     * @param {*} props
     */
    openModal (props = {}) {
      const h = this.$createElement
      props = _.defaultsDeep(props, {
        modalTitle: '',
        modalIconType: 'null',
        modalCancelButtonProps: { style: { display: 'none' } },
        modalOkButtonProps: { style: { display: 'none' } },
        modalClosable: true,
        modalKeyboard: true,
        modalWidth: 600,
        btnLink: false,
        buttons: [],
        zIndex: 2000
      })

      const normalizeButtonProps = (props) => {
        const buttonProps = _.defaultsDeep(props, {
          // btnClass: 'ml-4 mr-4',
          btnType: 'primary',
          btnGhost: true
        })

        if (typeof props?.btnCallback === 'function') {
          buttonProps.btnCallback = props.btnCallback
        }

        buttonProps.props = {
          ghost: buttonProps.btnGhost
        }

        // En antd el btnType "default" es aquel que no tiene type
        // por lo que no queda otra que no asignar la prop en este caso
        if (buttonProps.btnType !== 'default') {
          buttonProps.props.type = buttonProps.btnType
        }

        return buttonProps
      }

      // https://1x.antdv.com/components/button/
      let buttons = []
      if (!props.buttons?.length) {
        buttons.push(normalizeButtonProps(props))
      } else {
        buttons = props.buttons
      }

      buttons = buttons.map(button => normalizeButtonProps(button))

      const antdResultComponentProps = { }

      if (props.resultStatus !== 'information') {
        antdResultComponentProps.status = props.resultStatus
      }
      // Para que los modals no se superpongan
      Modal.destroyAll()
      // https://1x.antdv.com/components/modal/
      Modal.confirm({
        title: props.modalTitle,
        icon: props.modalIconType,
        cancelButtonProps: props.modalCancelButtonProps,
        okButtonProps: props.modalOkButtonProps,
        closable: props.modalClosable,
        keyboard: props.modalKeyboard,
        width: props.modalWidth,
        zIndex: props.zIndex,
        // https://1x.antdv.com/components/result/
        content: h(
          'a-result',
          {
            props: {
              ...antdResultComponentProps,
              title: props.resultTitle,
              'sub-title': props.resultSubtitle,
              extra: [
                h('div',
                  { class: 'desc' },
                  [
                    h('p',
                      {
                        style: { color: props.extraMessageColor },
                        // Permitimos que los mensajes puedan contener
                        // markup html con este truco tomado de:
                        // https://stackoverflow.com/a/57776306
                        domProps: { innerHTML: props.toastMessage }
                      }, [
                        // props.toastMessage
                      ])
                  ]
                ),
                h('div',
                  { class: 'd-flex flex-wrap justify-content-center', style: 'gap: .75rem' },
                  [
                    buttons.map(button => {
                      return h('a-button', {
                        class: button.btnClass,
                        props: button.props,
                        on: { click: () => {
                          if (button.btnCallback) {
                            button.btnCallback()
                          } else if (button.btnLink) {
                            if (button.btnLink === 'goback') {
                              this.$router.go(-1)
                            } else {
                              this.$router.push(button.btnLink)
                            }
                          }
                          Modal.destroyAll()
                        } }
                      }, button.btnText)
                    })
                  ]
                )
              ]
            }
          }
        )
      })
    },
    getOriginNotificationLink (url) {
      const pathArray = url.split('/')
      const protocol = pathArray[0]
      const host = pathArray[2]
      return protocol + '//' + host
    },
    lmToastSuccessPushNotification (link, title, icon, body) {
      const originLink = this.getOriginNotificationLink(link)
      const pathLink = link.replace(originLink, '')
      const appOrigin = window.location.origin
      const areOriginsAppAndLinkEquals = appOrigin === this.getOriginNotificationLink(link)
      const elementToCreate = {
        tag: areOriginsAppAndLinkEquals ? 'router-link' : 'a',
        attr: areOriginsAppAndLinkEquals ? 'to' : 'href',
        link: areOriginsAppAndLinkEquals ? pathLink : link
      }
      const h = this.$createElement
      const vNodesTitle = h(
        elementToCreate.tag,
        {
          class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
          attrs: {
            [elementToCreate.attr]: elementToCreate.link
          }
        },
        [
          h('strong', { class: 'mr-2' }, title),
          h(
            'img',
            { class: 'ml-auto',
              attrs: {
                id: 'foo',
                src: icon,
                width: 32,
                heigth: 32
              }
            })
        ]
      )
      const vNodesMsg = h(elementToCreate.tag, { attrs: { [elementToCreate.attr]: elementToCreate.link } }, body)
      this.$bvToast.toast(vNodesMsg, {
        title: [vNodesTitle],
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY,
        variant: 'info'
      })
    }
  },
  created () {
    const allIdToastToHideWhenMixinsIsCreated = ['lm-toast-success-internal-link']
    allIdToastToHideWhenMixinsIsCreated.forEach(idToast => {
      this.$bvToast.hide(idToast)
    })
  }
})
